<form #availableInternshipForm="ngForm" (ngSubmit)="onSubmit()">
    <div class="bottom">
        <div class="header">
            <div class="title">
                <h1>{{ 'available-internship-dialog.view-title' | translate }}</h1>
            </div>

            <div class="close">
                <mat-icon (click)="onCancel()" [attr.aria-label]="'common.close' | translate">close</mat-icon>
            </div>
        </div>

        <div class="content">
            <div class="content-information">
                <label>{{ 'internship-dialog.fields.internship-title' | translate }}</label>
                <input type="text" name="internshipsDataTitle" [(ngModel)]="availableInternshipData.title"  [disabled]="!isEditable" [class.isEditable]="isEditable">
            </div>

            <div class="content-information">
                <label>{{ 'available-internships.visibility.label' | translate }}</label>
                <select name="status" [(ngModel)]="availableInternshipData.visibility" required [disabled]="!isEditable" [class.isEditable]="isEditable" >
                <option value="" disabled selected>{{ 'available-internship-dialog.select-visibility' | translate }}</option>
                <option [ngValue]="true">{{ 'available-internships.visibility.enabled' | translate }}</option>
                <option [ngValue]="false">{{ 'available-internships.visibility.disabled' | translate }}</option>
                </select>
            </div>

            <div class="content-information">
                <label>{{ 'internships.table.position' | translate }}</label>
                <input type="text" name="internshipsDataPosition" [(ngModel)]="availableInternshipData.position"  [disabled]="!isEditable" [class.isEditable]="isEditable">
            </div>

            <div class="content-information">
                <label>{{ 'internship-dialog.fields.department' | translate }}</label>
                <input type="text" name="internshipsDataDepartment" [(ngModel)]="availableInternshipData.department"  [disabled]="!isEditable" [class.isEditable]="isEditable">
            </div>

                        <div class="content-information">
                <label>{{ 'profile.country' | translate }}</label>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-select [(ngModel)]="availableInternshipData.country" 
                                [compareWith]="compareCountries" (selectionChange)="onCountryChange()" 
                                name="country" [disabled]="!isEditable">
                        <mat-option *ngFor="let country of countries" [value]="country">
                            {{ country.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="content-information">
                <label>{{ 'profile.city' | translate }}</label>
                <mat-form-field appearance="outline" class="full-width" [class.disabled]="!availableInternshipData.country">
                    <input matInput placeholder="{{ 'profile.select-city' | translate }}" [(ngModel)]="citySearch"
                           (input)="onCityInput($any($event.target).value)" [matAutocomplete]="cityAuto"
                           [disabled]="!isEditable || !availableInternshipData.country" name="city">
                    <mat-autocomplete #cityAuto="matAutocomplete" (optionSelected)="onCitySelected($event.option.value)" [displayWith]="displayCityFn" autoActiveFirstOption>
                        <mat-option *ngFor="let city of filteredCities" [value]="city">{{ city.name }}</mat-option>
                        <mat-option *ngIf="filteredCities.length === 0 && citySearch" disabled>{{ 'profile.no-cities-found' | translate }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>


            <div class="content-information">
                <label>{{ 'available-internship-dialog.fields.internship-email' | translate }}</label>
                <input type="text" name="internshipsDataDepartment" [(ngModel)]="availableInternshipData.email"  [disabled]="!isEditable" [class.isEditable]="isEditable">
            </div>

            
        </div>

        <div class="content-information">
            <label>{{ 'profile.description' | translate }}</label>
            <textarea placeholder="{{ 'available-internship-dialog.placeholders.description' | translate }}" name="description" [(ngModel)]="description" maxlength="{{limitDescription}}" (input)="autoResizeTextarea($event)" class="description-textarea" [disabled]="!isEditable"></textarea>
            <p class="char-count">{{description.length}}/{{limitDescription}}</p>
        </div>

    </div>

    <div class="pulsanti">
        <button type="button" class="cancelButton" (click)="toggleCancel()" *ngIf="isEditable">
        <mat-icon>close</mat-icon>{{ 'common.cancel' | translate }}
        </button>

        <button class="saveButton"  *ngIf="isEditable">
        <mat-icon>save</mat-icon>{{ 'common.save' | translate }}
        </button>

        <button type="button" class="editButton" (click)="enableEdit()" *ngIf="!isEditable">
        <mat-icon>edit</mat-icon>{{ 'available-internship-dialog.edit' | translate }}
        </button>
    </div>
</form>
